// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__QvA_n","loaderOuter":"PageOverlayLoader_loaderOuter__3_b54"};